import { NextSeo } from 'next-seo'

import * as config from '@boutique/config'
import * as entity from '@boutique/entities'
import * as url from '@boutique/url'

type SeoProps = {
  pageUrl: url.Entry
  product: entity.product.Product
  shareableDescription: string
  strippedDescription: string
}

export function Seo({ pageUrl, product, shareableDescription, strippedDescription }: SeoProps): React.ReactElement {
  // FIXME: This condition should be removed when brands are no longer cold data
  let pageTitle = product.seo?.title || product.title
  pageTitle += product.brand && !('identifier' in product.brand) ? ` de ${product.brand.name}` : ''

  // This is to verify if brand is SlimColdUnmatchedBrand
  const rationale = 'identifier' in product.brand ? product.brand.rationale : ''

  return (
    <NextSeo
      title={`${pageTitle} | ${product.brand.name}`}
      description={shareableDescription}
      canonical={config.SITE_URL + pageUrl.path}
      openGraph={{
        title: `${pageTitle} de ${product.brand.name}, en vente sur ${config.SITE_NAME}`,
        description: product.seo?.description || rationale || strippedDescription,
        url: config.SITE_URL + pageUrl.path,
        images: product.images.map((image) => ({
          alt: image.alt ?? undefined,
          height: image.height ?? undefined,
          url: image.src,
          width: image.width ?? undefined,
        })),
        siteName: config.SITE_NAME,
      }}
      twitter={{
        site: config.SITE_TWITTER_HANDLE,
        cardType: 'summary_large_image',
      }}
      facebook={{ appId: config.FACEBOOK_APP_ID }}
      robotsProps={{
        maxImagePreview: 'large',
      }}
    />
  )
}
